import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IIncome } from "src/domain/entities"
import { incomeDeleteService } from "src/domain/services/income/incomeDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	income: IIncome
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const IncomeDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	income,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleIncomeDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await incomeDeleteService({ id: income.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [income, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Income: ${income.incomeNo}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleIncomeDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
